module.exports = __webpack_public_path__ + "static/board-19-952270b9fff568040f15a8c49e22adf4.jpg";